function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useId } from '@floating-ui/react';
import React from 'react';
import { forwardRef } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Box } from '../../Box';
import { usePopoverContext } from '../basePopover.utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var BasePopoverBody = forwardRef((props, ref) => {
  var {
    setDescriptionId
  } = usePopoverContext();
  var id = useId(); // Only sets `aria-describedby` on the `BasePopover` root element
  // if this component is mounted inside it.

  React.useLayoutEffect(() => {
    setDescriptionId(id);
    return () => setDescriptionId(undefined);
  }, [id, setDescriptionId]);
  var styles = useMultiStyleConfig('BasePopover', {});
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, props), {}, {
    __css: styles['body'],
    ref: ref,
    as: "p",
    id: id
  }));
});
BasePopoverBody.displayName = 'BasePopoverBody';
//# sourceMappingURL=BasePopoverBody.js.map